import React from "react";
import moment from "moment";
import "./style.css"; // Optionally, import your CSS file for styling
import clsx from "clsx";
import { isNumber } from "lodash";

type CalendarProps = {
  year?: number;
  month?: number;
  selectedDates: string[];
  setSelectedDates: (dates: string[]) => void;
};

const Calendar: React.FC<CalendarProps> = ({ year, month, selectedDates = [], setSelectedDates }) => {
  const today = moment();

  const currentYear = isNumber(year) ? year : today.year();
  const currentMonth = isNumber(month) ? month : today.month();
  const daysInMonth = moment(`${currentYear}-${currentMonth + 1}`, "YYYY-MM").daysInMonth();

  const handleDateClick = (date: string) => {
    let updatedSelectedDates = [...selectedDates];
    const isSelected = selectedDates.includes(date);

    if (isSelected) {
      updatedSelectedDates = updatedSelectedDates.filter((d) => d !== date);
    } else {
      updatedSelectedDates.push(date);
    }

    setSelectedDates(updatedSelectedDates);
  };

  const generateCalendarDays = () => {
    const firstDayOfMonth = (moment(`${currentYear}-${currentMonth + 1}-01`, "YYYY-MM-DD").day() + 6) % 7;
    const daysArray: JSX.Element[] = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      daysArray.push(<div className="empty" key={`empty-${i}`}></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = moment(new Date(currentYear, currentMonth, day)).format("YYYY-MM-DD");
      const isSelected = selectedDates.includes(date);

      const dayOfWeek = moment(date, "YYYY-MM-DD").day();
      const isWeekend = dayOfWeek === 6 || dayOfWeek === 0;

      daysArray.push(
        <div key={day} className={clsx("day", { selected: isSelected, weekend: isWeekend })} onClick={() => handleDateClick(date)}>
          {day}
        </div>
      );
    }

    return daysArray;
  };

  return (
    <div className="calendar rounded-md border-1 border-solid border-gray-200 flex-1">
      <div className="calendar-header">{moment(new Date(currentYear, currentMonth)).format("MMMM YYYY")}</div>
      <div className="calendar-grid">
        <div className="calendar-weekday">Mon</div>
        <div className="calendar-weekday">Tue</div>
        <div className="calendar-weekday">Wed</div>
        <div className="calendar-weekday">Thu</div>
        <div className="calendar-weekday">Fri</div>
        <div className="calendar-weekday">Sat</div>
        <div className="calendar-weekday">Sun</div>
        {generateCalendarDays()}
      </div>
    </div>
  );
};

export default Calendar;
